import React from 'react'
import moment from 'moment'
import {View, Text, StyleSheet, Image} from '@react-pdf/renderer'

const Header = () => {
    return(
        <View style={styles.container}>
            <Image 
                src="/documents/20143/43923/Sitoumus2050_logo.png/ba273cbb-641f-633f-91be-7a7f66956bc4?t=1638951761888" 
                style={{width: 200}}
            />
            <View style={{display: "flex", alignItems: "flex-end"}}>
                <Text style={styles.h1}>Toimenpideraportti</Text>
                <Text style={styles.h3}>Tulostettu {moment(Date.now()).format("DD.MM.YYYY")}</Text>
            </View>
        </View>
    )
}

export default Header

const styles = StyleSheet.create({
    h1: {
        fontSize: 20
    },
    h3: {
        fontSize: 12,
    },
    container: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        paddingBottom: 10,
        marginBottom: 40,
        borderBottom: "1px solid grey"
    }
})


// WEBPACK FOOTER //
// ./src/components/printable/Header.jsx